import { Button, Dropdown } from '@insurancemenu/imenu-components-lib';
import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';
import {
  ChevronDown,
  Description,
  DollarCircle,
  NoteAdd,
  PeopleGroup,
} from '@insurancemenu/imenu-components-lib/dist/icons';
import { getInitialSeedJSONsZip } from 'api/operations/productServiceV2';
import { getInitialSeedBenefitZip } from 'api/operations/proposalServiceV3';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useInitialSeedProductTemplatesStore } from 'store/pages/rfq/rfq-template/initial-seed-product-templates/pageStore';
import { useRootStore } from 'store/rootStore';

export const ReportActionsDropdown: React.FC = observer(() => {
  const rootStore = useRootStore();
  const { groupMaintenanceReportsModalStore, rateMaintenanceReportsModalStore } = useInitialSeedProductTemplatesStore();

  async function downloadBenefitSummaries(): Promise<void> {
    const sponsorId = rootStore.domainStoreV2.sponsorId;
    const url = await getInitialSeedBenefitZip(sponsorId);
    downloadByUrl(url);
  }

  async function downloadTemplateJsons(): Promise<void> {
    const sponsorId = rootStore.domainStoreV2.sponsorId;
    const url = await getInitialSeedJSONsZip(sponsorId);
    downloadByUrl(url);
  }

  function openGroupMaintenanceModal(): void {
    groupMaintenanceReportsModalStore.open();
  }

  function openRateMaintenanceModal(): void {
    rateMaintenanceReportsModalStore.open();
  }

  return (
    <Dropdown
      name="Download Reports"
      closedElement={
        <Button type="outlined" color="primary" size="large" rightIconProp={<ChevronDown />}>
          Download Reports
        </Button>
      }
      optionsWidth="23.5rem"
      options={[
        {
          label: 'All Benefit Summaries',
          icon: NoteAdd,
          value: 'benefit-summaries',
          onOptionClick: downloadBenefitSummaries,
        },
        {
          label: `All Template JSON'S`,
          icon: Description,
          value: 'template-jsons',
          onOptionClick: downloadTemplateJsons,
        },
        {
          label: `Group Maintenance`,
          icon: PeopleGroup,
          value: 'group-maintenance',
          onOptionClick: openGroupMaintenanceModal,
        },
        {
          label: `Rate Maintenance`,
          icon: DollarCircle,
          value: 'rate-maintenance',
          onOptionClick: openRateMaintenanceModal,
        },
      ]}
    />
  );
});
